import React from 'react';
import { GiftIcon } from 'lucide-react';
import { BONUSES } from '../data/bonuses';
import { scrollToBuy } from '../utils/constants';
export function Bonuses() {
  return <section aria-labelledby="bonuses-title" className="w-full bg-panel px-4 py-8" data-id="element-20" data-mp="plsnad7r1gdg">
      <div className="mx-auto max-w-4xl" data-id="element-21" data-mp="asz34ehj8c2g">
        <div className="text-center" data-id="element-22" data-mp="ftmwv7x5b70d">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-mustard/15 px-2.5 py-0.5 font-head text-[10px] font-semibold uppercase tracking-wide text-mustard" data-id="element-23" data-mp="fslesjhppk95">
            <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-24" data-mp="5x1lm4uj8zo3" />
            Also included at no extra cost
          </span>
          <h2 id="bonuses-title" className="mt-1 font-head text-2xl font-bold uppercase leading-none text-white sm:text-4xl" data-id="element-25" data-mp="3o36canz55gkh">
            Five strategic bonuses
          </h2>
          <p className="mt-0.5 text-[11px] text-silver" data-id="element-26" data-mp="1mb9zlb18m0o4">
            100% included today with your SPANISH TEACHER PRO™ system.
          </p>
        </div>

        <div className="mt-3 grid gap-2 md:grid-cols-2" data-id="element-27" data-mp="3ieg938a9qf2y">
          {BONUSES.map((bonus, index) => <button key={bonus.number} type="button" onClick={scrollToBuy} aria-label={`Go to the purchase section — ${bonus.title}`} className={`flex flex-col rounded-xl border border-white/10 border-l-4 bg-night p-3 text-left transition-colors duration-150 ease-out hover:border-cta/50 ${bonus.accent} ${index === BONUSES.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-28" data-mp="3ic3gm16vwmbn" data-mpi={index}>
              <span className="flex items-center gap-1.5" data-id="element-29" data-mp="2zgdemdyybpxr">
                <span className={`h-1.5 w-1.5 rounded-full ${bonus.dot}`} aria-hidden="true" data-id="element-30" data-mp="2ugr3ca2oojrl" />
                <span className="font-head text-[10px] font-semibold uppercase tracking-widest text-silver/70" data-id="element-31" data-mp="38g0hz5b8r5tg">
                  Bonus {bonus.number}
                </span>
              </span>
              <span className="mt-0.5 block font-head text-base font-bold uppercase leading-tight text-white sm:text-lg" data-id="element-32" data-mp="nq1dx6xbhgw4">
                {bonus.title}
              </span>
              <span className="mt-1 block text-[12px] font-semibold leading-snug text-cta" data-id="element-33" data-mp="it15wqgwq42d">
                {bonus.hook}
              </span>
              <span className="mt-1 block text-[12px] leading-snug text-silver" data-id="element-34" data-mp="3hhhqmmwfzz6j">{bonus.body}</span>
              <span className="mt-auto block pt-1.5 text-[9px] font-semibold uppercase leading-snug tracking-wide text-silver/60" data-id="element-35" data-mp="3lj33i88z8dgq">
                {bonus.tags}
              </span>
            </button>)}
        </div>
      </div>
    </section>;
}